import {makeAutoObservable} from "mobx"


interface NavbarItem {
    label: string
    className?: string
    path?: string
    preview?: boolean
    icon?: string[]
}

class NavbarStore {

    get items(): NavbarItem[] {
        return [
            {
                label: 'Dashboard',
                path: `/dashboard`,
                className: 'label',
                icon: ['dashboard']
            },
            {
                label: 'Fahrzeuge'
            },
            {
                label: 'Fahrzeughistorie',
                path: '/vhs',
                icon: ['deployed_code_history']
            },
            {
                label: 'Scandatenimport',
                path: `/sea/document`,
                icon: ['document_scanner']
            },
            {
                label: 'Fahrzeugerfassung',
                path: `/vda`,
                icon: ['car_tag']
            },
            {
                label: 'Einlagerung',
                path: '/sls',
                icon: ['home_storage']
            },
            {
                label: 'Versand',
                path: '/fms',
                icon: ['delivery_truck_speed']
            },
            {
                label: 'Umlagerung',
                path: '/sts',
                icon: ['move_group']
            },
            {
                label: 'Sicherheitscodes',
                path: `/sca`,
                icon: ['keyboard_lock']
            },
            {
                label: 'Administration'
            },
            {
                label: 'Kundenverwaltung',
                path: `/cms`,
                icon: ['business_center']
            },
            {
                label: 'Benutzerverwaltung',
                path: `/ums/user`,
                icon: ['manage_accounts']
            },
            {
                label: 'Druckerverwaltung',
                path: `/pms`,
                icon: ['print']
            },
            {
                label: 'Versandverwaltung',
                path: `/fms/shippingclient`,
                icon: ['package']
            },
        ]
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const navbarStore = new NavbarStore()

export {
    navbarStore
}
